import {gatewayShortJson} from '../../api';

const CORE = process.env.REACT_APP_CORE;

export const getEstados = () => (
  gatewayShortJson.get(`${CORE}/estados`)
);
